import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import AmenitiesListContainer from './containers/amenities-list/amenities-list.container';
/**
 * function AmenityModule components
 */
export const AmenityModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.AMENITY_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.AMENITY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.AMENITY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={AmenitiesListContainer}
      />
    </>
  );
};
